// extracted by mini-css-extract-plugin
export default {"button":"Button_button__1e8jo","inverted":"Button_inverted__Wb-Ro"};